<template>
  <div class="wrapper">
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" :inline="true" size="mini">
        <el-form-item label="种类名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.typeName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="searchReset">重置</el-button>
          <el-button size="mini" type="primary" @click="handleAdd()"
            >新增</el-button
          >
          <el-popconfirm
            style="margin-left: 10px"
            title="确定删除吗？"
            @confirm="handleDelete()"
          >
            <template #reference>
              <el-button size="mini" type="danger">删除</el-button>
            </template>
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #handlerSlot="slotData">
        <el-button size="mini" @click="handleEdit(slotData.data.row)"
          >修改</el-button
        >
        <!-- <el-button
          size="mini"
          type="success"
          @click="handleDetail(slotData.data.row, true)"
          >详情</el-button
        > -->
      </template>
    </e-table>
    <modal-form ref="modalForm" @ok="modalFormOk" @editOk="editOk"></modal-form>
  </div>
</template>

<script>
import { httpAction } from "@/api/manage";
import modalForm from "./component/classifyModal";

import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
export default {
  components: { eTable, modalForm },
  mixins: [listMixin],
  props: {},
  data() {
    return {
      deleteKey: "userId",
      url: {
        list: "/wlMallType/queryPage",
        delete: "/wlMallType/delType",
        // productIsShow: "/mallProduct/productIsShow",
      },

      //字段权限
      columns: [
        {
          field: "pcode",
          label: "pcode",
        },
        {
          field: "typeCode",
          label: "typeCode",
        },
        {
          field: "typeName",
          label: "种类名称",
        },
        {
          width: 160,
          label: "编辑",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    fetchData() {
      console.log(this.ipagination.page);
    },
    add(val) {
      console.log(val);
    },
    edit(val) {},
    del(val) {},
    editOk() {
      this.loadData(1);
    },
    handleDelete: function (id) {
      if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
        httpAction(this.url.delete, this.selectedRowKeys, "post").then(
          (res) => {
            if (res.code == 200) {
              //重新计算分页问题
              this.reCalculatePage(1);
              this.$message.success("删除成功");
              this.onClearSelected();
              this.loadData();
            } else {
              this.$message.warning(res.msg);
            }
          }
        );
      } else {
        this.$message.warning("请选择商品后删除");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
